import { Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { environment } from '../../../environments/environment';

@Injectable()
export class LmTitleService {
  private prefix: string;

  constructor(private titleService: Title) {}

  setPrefix(prefix: string) {
    this.prefix = prefix;
  }

  setTitleSuffix(suffix: string) {
    this.titleService.setTitle(`${this.prefix ? this.prefix : 'Admin'} | ${suffix}`);
  }
}
